  import React, { useState, useRef, useEffect } from 'react';
  import SectionHeader from '../../ui/SectionHeader';
  import PlanCard from './PlanCard';
  import CarouselControls from './CarouselControls';
  import MembershipBenefits from './MembershipBenefits';
  import '../../../styles/components/sections/Memberships.css';

  const Memberships = ({ membershipPlans }) => {
    const [currentPlanIndex, setCurrentPlanIndex] = useState(0);
    const [cardsToShow, setCardsToShow] = useState(3);
    const sliderRef = useRef(null);
    const trackRef = useRef(null);
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);

    useEffect(() => {
      const updateCardsToShow = () => {
        const width = window.innerWidth;
        if (width < 768) {
          setCardsToShow(1);
        } else if (width < 1200) {
          setCardsToShow(2);
        } else {
          setCardsToShow(3);
        }
      };

      updateCardsToShow();
      window.addEventListener('resize', updateCardsToShow);
      return () => window.removeEventListener('resize', updateCardsToShow);
    }, []);

    const maxIndex = membershipPlans.length - 1; // Last plan index

    const nextPlan = () => {
      setCurrentPlanIndex((prev) => Math.min(prev + 1, maxIndex));
    };

    const prevPlan = () => {
      setCurrentPlanIndex((prev) => Math.max(prev - 1, 0));
    };

    const handleTouchStart = (e) => {
      setTouchStart(e.targetTouches[0].clientX);
    };

    const handleTouchMove = (e) => {
      setTouchEnd(e.targetTouches[0].clientX);
    };

    const handleTouchEnd = () => {
      if (!touchStart || !touchEnd) return;
      
      const distance = touchStart - touchEnd;
      const isLeftSwipe = distance > 50;
      const isRightSwipe = distance < -50;

      if (isLeftSwipe) nextPlan();
      if (isRightSwipe) prevPlan();

      setTouchStart(0);
      setTouchEnd(0);
    };

    const isAtStart = currentPlanIndex === 0;
    const isAtEnd = currentPlanIndex >= maxIndex;

    const getActiveCardIndex = () => {
      return currentPlanIndex; // Always highlight the card matching the active dot
    };

    // Calculate translation
    const getTransform = () => {
      if (cardsToShow === 1) {
        // Mobile: pixel-based for exact positioning
        if (!sliderRef.current) return `translateX(0)`;
        const sliderWidth = sliderRef.current.offsetWidth;
        return `translateX(-${currentPlanIndex * sliderWidth}px)`;
      }
      
      if (cardsToShow === 2) {
        // Tablet: show 2 cards, don't let it scroll past showing the last 2 cards
        const maxScroll = membershipPlans.length - 2;
        const scrollIndex = Math.min(currentPlanIndex, maxScroll);
        return `translateX(-${scrollIndex * 50}%)`;
      }
      
      // Desktop: show 3 cards, don't let it scroll past showing the last 3 cards
      const maxScroll = membershipPlans.length - 3;
      const scrollIndex = Math.min(currentPlanIndex, maxScroll);
      return `translateX(-${scrollIndex * (100 / 3)}%)`;
    };

    return (
      <section id="memberships" className="memberships">
        <div className="container">
          <SectionHeader
            badge="Mesečni paketi"
            title="Izaberite plan po svojoj meri"
            subtitle="Uštedite vreme i novac uz fleksibilne opcije pranja, kreirane da odgovore na potrebe svakog vozača."
            icon="💎"
          />

          <div className="membership-container">
            <div 
              ref={sliderRef}
              className="membership-slider"
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
            >
              <div 
                ref={trackRef}
                className="membership-track" 
                style={{
                  transform: getTransform()
                }}
              >
                {membershipPlans.map((plan, index) => (
                  <PlanCard 
                    key={plan.id}
                    plan={plan}
                    index={index}
                    activeIndex={getActiveCardIndex()}
                    cardsToShow={cardsToShow}
                  />
                ))}
              </div>

              <CarouselControls 
                onNext={nextPlan}
                onPrev={prevPlan}
                currentIndex={currentPlanIndex}
                totalPlans={membershipPlans.length}
                setCurrentIndex={setCurrentPlanIndex}
                isAtStart={isAtStart}
                isAtEnd={isAtEnd}
                maxIndex={maxIndex}
                cardsToShow={cardsToShow}
              />
            </div>
            
          </div>
        </div>
      </section>
    );
  };

  export default Memberships;